module.exports = __webpack_public_path__ + "img/roaster.ed0737c3.png";